export const rulesForInfoStepAlert = {
  HYPERBARIC_FLOW_NOX: {
    "NO RED FLAG": {
      QUIZ_ANSWERED: {
        title: ({ procedure, scheduleEvents }) => {
          if (
            scheduleEvents.some(
              (e) => e.type === "TEST_PROCEDURE" && e.attended === null
            )
          ) {
            return `Agendaste tu sesión de ${procedure.procedure.title}`;
          }

          if (
            scheduleEvents.some(
              (e) => e.type === "TEST_PROCEDURE" && e.attended === true
            )
          ) {
            return `Completaste tu sesión de ${procedure.procedure.title} agenda tu cita el la pestaña de valoración.`;
          }

          return `Completaste tu encuesta: ${procedure.assessment.title}.`;
        },
        subTitle: ({ procedure, scheduleEvents }) => {
          if (
            scheduleEvents.some(
              (e) => e.type === "TEST_PROCEDURE" && e.attended === null
            )
          ) {
            return null;
          }

          if (
            scheduleEvents.some(
              (e) => e.type === "TEST_PROCEDURE" && e.attended === true
            )
          ) {
            return null;
          }

          return `Agenda tu sesión de ${procedure.procedure.title} en la pestaña de procedimiento.`;
        },
      },
      QUIZ_SATISFACTION_ANSWERED: {
        title: "Completaste tu procedimiento.",
        subTitle: "Ya puedes cerrar esta página.",
      },
      FINISHED: {
        title: "Completaste tu procedimiento.",
        subTitle: "Ya puedes cerrar esta página.",
      },
    },
  },
  CORE_NOX: {
    "FAST TRACK": {
      QUIZ_ANSWERED: {
        title: ({ procedure }) => {
          return `Completaste tu encuesta: ${procedure.assessment.title}.`;
        },
        subTitle: "Agenda tu cita en la pestaña de valoración.",
      },
      QUIZ_SATISFACTION_ANSWERED: {
        title: "Completaste tu procedimiento.",
        subTitle: "Ya puedes cerrar esta página.",
      },
      FINISHED: {
        title: "Completaste tu procedimiento.",
        subTitle: "Ya puedes cerrar esta página.",
      },
    },
    "SLOW TRACK": {
      QUIZ_ANSWERED: {
        title: "Completaste tu encuesta.",
        subTitle: "Agenda tu cita en la pestaña de valoración.",
      },
      QUIZ_SATISFACTION_ANSWERED: {
        title: "Completaste tu procedimiento.",
        subTitle: "Ya puedes cerrar esta página.",
      },
      FINISHED: {
        title: "Completaste tu procedimiento.",
        subTitle: "Ya puedes cerrar esta página.",
      },
    },
  },
  CORE_SOGAMOSO: {
    "FAST TRACK": {
      QUIZ_ANSWERED: {
        title: ({ procedure }) => {
          return `Completaste tu encuesta: ${procedure.assessment.title}.`;
        },
        subTitle: "Agenda tu cita de valoración en la pestaña de valoración.",
      },
      QUIZ_SATISFACTION_ANSWERED: {
        title: "Completaste tu procedimiento.",
        subTitle: "Ya puedes cerrar esta página.",
      },
      FINISHED: {
        title: "Completaste tu procedimiento.",
        subTitle: "Ya puedes cerrar esta página.",
      },
    },
    "SLOW TRACK": {
      QUIZ_ANSWERED: {
        title: "Completaste tu encuesta.",
        subTitle: "Agenda tu cita en la pestaña de valoración.",
      },
      QUIZ_SATISFACTION_ANSWERED: {
        title: "Completaste tu procedimiento.",
        subTitle: "Ya puedes cerrar esta página.",
      },
      FINISHED: {
        title: "Completaste tu procedimiento.",
        subTitle: "Ya puedes cerrar esta página.",
      },
    },
  },
};
